// =============================================================================
// transportKursu — tor POWŁOKI (JWT Supabase) do kursu Akademii.
//
// To jest dotychczasowe zachowanie `KursSzkolenia` wyjęte za interfejs
// `TransportKursu` (patrz `transportKursuCore.ts`): program i postęp
// z `/api/nexus/szkolenie/:tenant_id?odbiorca=`, slajdy z `/rozdzial`,
// odhaczenie z `/ukoncz` (z `odbiorca` w ciele), trener przez `/api/nexus/chat`.
// Tożsamość rozmówcy niesie bearer z sesji Supabase (`nexusApi`), więc ten
// plik — inaczej niż rdzeń — importuje Supabase pośrednio i nie nadaje się
// do importu w testach bez env.
// =============================================================================

import { nexusGet, nexusPost } from '../../lib/nexusApi';

import type {
  OdbiorcaSzkolenia,
  Slajd,
  SzkolenieOdpowiedz,
  TransportKursu,
} from './transportKursuCore';

export interface TransportPowlokiOpcje {
  orgId: string;
  odbiorca: OdbiorcaSzkolenia;
  /** Bez `userId` trener milczy — czat wymaga rozmówcy. */
  userId?: string;
}

export function transportPowloki({
  orgId,
  odbiorca,
  userId,
}: TransportPowlokiOpcje): TransportKursu {
  const zapytanie = odbiorca === 'uzytkownik' ? '?odbiorca=uzytkownik' : '';
  const transport: TransportKursu = {
    program: () => nexusGet<SzkolenieOdpowiedz>(`/api/nexus/szkolenie/${orgId}${zapytanie}`),
    rozdzial: (klucz, o) =>
      nexusPost<{ slajdy: Slajd[] }>(
        `/api/nexus/szkolenie/${orgId}/rozdzial`,
        { rozdzial: klucz },
        { timeoutMs: o?.timeoutMs }
      ),
    ukoncz: (klucz) =>
      nexusPost<{ ukonczone: number; wszystkie: number }>(`/api/nexus/szkolenie/${orgId}/ukoncz`, {
        rozdzial: klucz,
        odbiorca,
      }),
  };
  if (userId) {
    transport.czat = async (tekst, conversationId) => {
      const dane = await nexusPost<{ response: string; conversation_id?: string }>(
        '/api/nexus/chat',
        {
          tenant_id: orgId,
          user_id: userId,
          message: tekst,
          conversation_id: conversationId,
        },
        { timeoutMs: 90_000 }
      );
      return { odpowiedz: dane.response, conversationId: dane.conversation_id };
    };
  }
  return transport;
}
